import { appsConf } from "../appDataConf.js";
import { chunksConf } from "../chunkDataConf.js";
// import { dbName } from "../consts";
import { gudhubIndexedDBManager } from "../IndexedDBService.js";
import { chunksMergeConf } from "../storeManagerConf/chunkCacheStoreManagerConf.js";
import { BaseStoreManager } from "./BaseStoreManager.js";

export class AppStoreManager extends BaseStoreManager {
  constructor() {
    super(gudhubIndexedDBManager, appsConf.store);
  }

  async getApp(id) {

    return this.getItem(id);

    // return dbManager.enqueueOperation('apps', 'readonly', (store) => store.get(id));
  }

  async addApp(id, data) {
    return this.addItem(id, data);

    // return dbManager.enqueueOperation('apps', 'readwrite', (store) => store.add(app));
  }

  async putApp(id, data) {
    return this.putItem(id, data);

    // return dbManager.enqueueOperation('apps', 'readwrite', (store) => store.add(app));
  }

  async hasApp(id) {
    return this.hasItem(id);
  }

  async deleteApp(id) {
    return this.deleteItem(id);

    // return dbManager.enqueueOperation('apps', 'readwrite', (store) => store.delete(id));
  }

  // Additional methods specific to AppStoreManager if necessary
}

export class ChunksStoreManager extends BaseStoreManager {
  constructor() {
    super(gudhubIndexedDBManager, chunksConf.store);
  }


  async getChunk(id) {

    return this.getItem(id);

    // return dbManager.enqueueOperation('apps', 'readonly', (store) => store.get(id));
  }

  async addChunk(id, chunk) {
    return this.addItem(id, chunk);

    // return dbManager.enqueueOperation('apps', 'readwrite', (store) => store.add(app));
  }

  async putChunk(id, chunk) {
    return this.putItem(id, chunk);

    // return dbManager.enqueueOperation('apps', 'readwrite', (store) => store.add(app));
  }

  async deleteChunk(id) {
    return this.deleteItem(id);

    // return dbManager.enqueueOperation('apps', 'readwrite', (store) => store.delete(id));
  }


    //use item methods from BaseStoreManager !!!!!!!


  // Additional methods specific to ChunksStoreManager if necessary
}

export class MergedChunksStoreManager extends BaseStoreManager {
  constructor() {
    super(gudhubIndexedDBManager, chunksMergeConf.store);
  }

  async get(id) {

    return this.getItem(id);

    // return dbManager.enqueueOperation('apps', 'readonly', (store) => store.get(id));
  }

  async add(id, chunk) {
    return this.addItem(id, chunk);

    // return dbManager.enqueueOperation('apps', 'readwrite', (store) => store.add(app));
  }

  //TODO update here ok?
  async put(id, chunk) {
    return this.putItem(id, chunk);

    // return dbManager.enqueueOperation('apps', 'readwrite', (store) => store.add(app));
  }

  async delete(id) {
    return this.deleteItem(id);

    // return dbManager.enqueueOperation('apps', 'readwrite', (store) => store.delete(id));
  }
}